export default __webpack_public_path__ + "static/media/i (7).2983f6f5.jpg";